import { Apis, Labels } from '../../app.constants';
import SweetAlert from '../../../components/Shared/Notification';
import APIService from '../../APIService';

const FlowBuilderActions = () => {
  const getFlowList = async (filters) => {
    let res = await APIService.get(
      `${Apis.getFlowList}?next_page=${filters?.page || 1}&search=${filters?.search}&page_limit=${filters?.rowsPerPage || 10}&organisation_id=${filters?.organisationId || ''}&bot_number=${filters?.botNumber || ''}`
    );
    if (res.status == 200) return res;
  };

  const createFlow = async (data) => {
    let res = await APIService.post(`${Apis.createFlow}`, data);
    if (res.status == 201) return res;
  };

  const updateFlow = async (flowId, data) => {
    let res = await APIService.patch(`${Apis.updateFlow}/${flowId}`, data);
    return res;
  };

  const checkFormValidation = async (data) => {
    let res = await APIService.get(
      `${Apis.checkFormValidation}?company_id=${data?.company_id}&title=${data?.title}`
    );
    return res;
  };

  const deleteFlow = async (flowId, data) => {
    let res = await APIService.remove(`${Apis.deleteFlow}/${flowId}`);
    if (res?.status === 200) {
      // SweetAlert(Labels.Success,"success");
      return res;
    } else {
      // SweetAlert(Labels.Error, 'error');
    }
  };

  const createNodeEdges = async (data) => {
    let res = await APIService.post(`${Apis.createNodeEdges}`, data);
    if (res?.status === 201) {
      return res;
    }
  };
  const getNodeEdgesById = async (flowId) => {
    let res = await APIService.get(`${Apis.getNodeEdges}${flowId}`);
    if (res?.status === 200) return res?.data;
  };

  const getBotFlowDetails = async (flowId) => {
    let res = await APIService.get(`${Apis.getBotFlowDetails}${flowId}`);
    return res;
  };

  const checkPatterns = async (data, patterns) => {
    try {
      const res = await APIService.post(
        `${Apis.checkPatterns}?company_id=${data?.company_id}&bot_number=${data?.phone_number_id}`,
        patterns
      );
      if (res.status === 200) {
        return res?.data;
      }
      return null;
    } catch (error) {
      console.error('Error in checkPatterns:', error);
      throw error;
    }
  };

  const checkFlowName = async (data) => {
    try {
      const res = await APIService.get(
        `${Apis.checkFlowName}?company_id=${data?.company_id}&title=${data?.title}&bot_number=${data?.phone_number_id}`
      );
      if (res.status === 200) {
        return res?.data;
      }
      return null;
    } catch (error) {
      console.error('Error in checkPatterns:', error);
      throw error;
    }
  };

  const getCampaignByOrganisation = async (data) => {
    let params = `?next_page=${data?.next_page}&search=${data?.search}&organisation_id=${data?.organisationId}`;
    let res = await APIService.get(`${Apis.getCampaingByOrganisation}${params}`);
    if (res.status == 200) return res?.data;
  };
  const onUploadProgress = (progressEvent) => {
    console.log(progressEvent);
    // const { loaded, total } = progressEvent;
    // const percent = Math.floor((loaded * 100) / total);
    // setProgressBar(percent);
  };
  const uploadMediaToWhatsapp = async (data) => {
    let res = await APIService.uploadFile(`${Apis.uploadMediaToWhatsapp}`, data, onUploadProgress);
    return res;
  };

  const whatsappBusinessAccounts = async (comapnyId) => {
    let res = await APIService.get(`${Apis.whatsappBusinessAccounts}?company_id=${comapnyId}`);
    return res;
  };

  const getBotBuilderCatalogList = async (botNumber) => {
    let res = await APIService.get(`${Apis.getBotBuilderCatalogList}?bot_number=${botNumber}`);
    if (res?.status === 200) return res?.data;
  };

  const getBotBuilderProductList = async (data) => {
    let res = await APIService.get(
      `${Apis.getBotBuilderProductList}?bot_number=${data?.bot_number}&catalog_id=${data?.catalog_id}&page=${data?.page || 1}&per_page=${data?.rowsPerPage || 10}&search=${data?.search || ''}`
    );
    if (res?.status === 200) return res?.data;
  };

  const downloadBotFlows = async (data) => {
    window.location.href = `${process.env.REACT_APP_API_URL}/v0/ui/bot-builder/download-botflow/?organisation_id=${data?.organisationId || ''}&bot_number=${data?.botNumber || ''}`;
  };

  const fetchFlowDetailByFlowType = async (data) => {
    let res = await APIService.get(
      `${Apis.fetchFlowDetailByFlowType}?company_id=${data?.company_id}&phone_number=${data?.phone_number_id}`
    );
    if (res?.status === 200) return res?.data;
  };

  const scheduleBot = {
    get: async (params) => {
      return await APIService.get(`${Apis.scheduleBot}?flow_id=${params?.flowId || ''}`);
    },
    post: async (data) => {
      return await APIService.post(`${Apis.scheduleBot}`, data);
    },
    put: async (data) => {
      return await APIService.put(`${Apis.scheduleBot}`, data);
    },
    delete: async (params) => {
      const queryParams = new URLSearchParams(params).toString();
      return await APIService.remove(`${Apis.scheduleBot}?${queryParams}`);
    },
  };

  return {
    getFlowList,
    createFlow,
    updateFlow,
    checkFormValidation,
    deleteFlow,
    createNodeEdges,
    getNodeEdgesById,
    checkPatterns,
    checkFlowName,
    getCampaignByOrganisation,
    uploadMediaToWhatsapp,
    whatsappBusinessAccounts,
    getBotFlowDetails,
    getBotBuilderCatalogList,
    getBotBuilderProductList,
    downloadBotFlows,
    fetchFlowDetailByFlowType,
    scheduleBot,
  };
};

export { FlowBuilderActions };
